import { render, staticRenderFns } from "./OtpLoginPage.vue?vue&type=template&id=19f33c33"
import script from "./OtpLoginPage.vue?vue&type=script&lang=ts"
export * from "./OtpLoginPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f33c33')) {
      api.createRecord('19f33c33', component.options)
    } else {
      api.reload('19f33c33', component.options)
    }
    module.hot.accept("./OtpLoginPage.vue?vue&type=template&id=19f33c33", function () {
      api.rerender('19f33c33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/account/login/OtpLoginPage.vue"
export default component.exports